module.exports = __webpack_public_path__ + "img/button_at-icon.88d1c73a.svg";